import { FC, ReactNode, useCallback, useMemo, useState } from 'react';
import { readStoredConsent, writeStoredConsent } from './consent';
import { ConsentContext, ConsentContextValue } from './ConsentContext';

/**
 * Holds the visitor's choice. It only holds and persists it: AnalyticsGate is what starts and stops
 * the analytics tools from it.
 */
export const ConsentProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const [{ decided, choices }, setState] = useState(readStoredConsent);
    const [reopened, setReopened] = useState(false);

    const commit = useCallback((analytics: boolean) => {
        const next = { analytics };
        writeStoredConsent(next);
        setState({ decided: true, choices: next });
        setReopened(false);
    }, []);

    const value = useMemo<ConsentContextValue>(
        () => ({
            decided,
            analytics: choices.analytics,
            bannerOpen: !decided || reopened,
            accept: () => commit(true),
            reject: () => commit(false),
            reopen: () => setReopened(true),
            close: () => setReopened(false),
        }),
        [decided, choices.analytics, reopened, commit],
    );

    return <ConsentContext.Provider value={value}>{children}</ConsentContext.Provider>;
};
